import { Observable } from 'rxjs'
import { map, pluck } from 'rxjs/operators'

import { Item } from '@skinsoft/types'
import { OfflineDataFetcher } from '@skinsoft/offline'

export class ExpressionOfflineDataFetcher extends OfflineDataFetcher<Item>{

    constructor(cacheKey: string) {
        super(cacheKey);
    }

    /*public fetchWemiFromId(id: string): Observable<any> {
        return super.fetchOneFromId(id)
    }*/

    protected idMatcher(entity: any, id: string) {
        if (entity.expression) {
            return entity.expression.id === id;
        }
        return false;
    }

}